<div class="idp-step-section__header">
  <idp-step
    [attr.aria-hidden]="ariaHiddenValue"
    [label]="content.step"
    [secondary]="secondary"
    class="header__step"
  ></idp-step>
  <h2
    [attr.data-test-section-title]="content.title"
    [attr.id]="ariaLabelledValue"
    [ngClass]="'header__' + (secondary ? 'secondary' : 'title')"
  >
    <span class="sr-only">{{ content.step }} {{ ' ' }}</span>
    {{ content.title }}
  </h2>
</div>
<div
  *ngIf="content.subtitle"
  [attr.data-test-section-subtitle]="content.subtitle"
  [innerHTML]="content.subtitle"
  class="idp-step-section__subtitle"
></div>
<div
  *ngIf="content.description"
  [innerHTML]="content.description | trustContent : 'html'"
  [ngClass]="'idp-step-section__' + (secondary ? 'secondary' : 'description')"
></div>
<div [attr.data-test-section-content]="true" class="idp-step-section__content">
  <ng-content></ng-content>
</div>
